import '../../utils/index.mjs';
import _sfc_main from './src/collapse2.mjs';
import _sfc_main$1 from './src/collapse-item2.mjs';
export { collapseEmits, collapseProps, emitChangeFn } from './src/collapse.mjs';
export { collapseItemProps } from './src/collapse-item.mjs';
import { withInstall, withNoopInstall } from '../../utils/vue/install.mjs';

const ElCollapse = withInstall(_sfc_main, {
  CollapseItem: _sfc_main$1
});
const ElCollapseItem = withNoopInstall(_sfc_main$1);

export { ElCollapse, ElCollapseItem, ElCollapse as default };
//# sourceMappingURL=index.mjs.map
